/**
 * ResolutionIcon/index.js
 * desc: system icon for resolution step type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ResolutionIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="resolution icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.resolution.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg"><path d="M9.953 2.118L9.529 0H0v18h2.118v-7.412h5.93l.423 2.118h7.411V2.118h-5.93z"/></svg>
    </IconButton>
);


export default ResolutionIcon;
